/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { LicenseDTO } from "../models/license-dto";
import { LicensingService } from "../services/licensing.service";
import { Input, Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class LicensesResolver implements Resolve<LicenseDTO[]> {

  constructor(
    private mLicensingService: LicensingService
  ) {}

  async resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<LicenseDTO[]> {
    try {
      return await this.mLicensingService.getInstalledLicenses();
    } catch (error) {
      console.error("Problem resolving Licenses.", error);
    }
  }

}
